import _ from "lodash";

export type IconObj = {
  iconName: string;
  type: string;
  category: string;
};

const isJsonString = (str: string | IconObj): boolean => {
  if (!_.isString(str)) {
    return false;
  }
  if (
    (_.startsWith(str, "{") && _.endsWith(str, "}")) ||
    (_.startsWith(str, "[") && _.endsWith(str, "]"))
  ) {
    try {
      const parsed = JSON.parse(str);
      return _.isObject(parsed) && !_.isNull(parsed);
    } catch (e) {
      return false;
    }
  }

  return false;
};

export function getIconParams(icon): IconObj {
  const iconObj =
    icon === "" || icon === undefined
      ? { iconName: "", type: "antd", category: "direction" }
      : isJsonString(icon)
        ? JSON.parse(icon)
        : _.isObject(icon)
          ? icon
          : { iconName: icon, type: "appsmith", category: "appsmith" };
  return iconObj;
}
